import React from 'react'
import { flowRight } from 'lodash'
import { Trans, useTranslation } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

import ControlledModal from 'components/Modal/ControlledModal'
import Link from 'components/Link'

const FinancingMakeOfferSubmittedModal = () => {
    const { t } = useTranslation('financing')

    return (
        <ControlledModal
            routedModal
            name="financing-make-offer-submitted-modal"
            context="financingMakeOfferSubmittedModal"
            initialTitle={t('financing:financedOffer.submittedMessage.title')}
            okButtonTxt={t('financing:financedOffer.submittedMessage.close')}
            okButtonClasses="button"
            requireUserInput={true}
            closeOnRouteChange={false}
        >
            <Trans i18nKey="financing:financedOffer.submittedMessage.message">
                Huomioi, että rahoitusta käyttäessäsi sinun tulee ottaa ajoneuvolla pakollinen liikennevakuutus viimeistään kaupanteon yhteydessä. Rahoitusyhtiö edellyttää myös kaskovakuutusta, mikäli rahoitusosuus on yli 16 000 euroa. Lue tarkemmin <Link to="/pdf/Osamaksusopimuksen_yleiset_ehdot-Svea.pdf" target="_blank" trackName="financingTermsAndConditions">rahoituksen ehdoista</Link>.
            </Trans>
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
)(FinancingMakeOfferSubmittedModal)
